module.exports = __webpack_public_path__ + "static/media/EN-Eid-Al-Fitr-No-Text.03e6ab27.jpg";